import React from 'react';
import { Section } from './ui/Section';
import { X, Flame, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function AntiagingTruth() {
  const lies = ["Cremas 'antiedad' que prometían borrar arrugas en 7 días (y nunca pasó nada)", "Serums con nombres complicados que supuestamente 'revertían el envejecimiento'", 'Tratamientos caros en dermatólogos que solo atacaban síntomas superficiales', "Suplementos 'mágicos' que te vendieron por Instagram"];
  const truths = ['Inflamación crónica (tu cuerpo en estado de alerta permanente)', 'Estrés oxidativo (células dañándose más rápido de lo que se reparan)', 'Desbalance hormonal (cortisol alto, insulina desregulada)', "Nutrición deficiente (comés 'sano' pero no lo que tu cuerpo necesita ahora)", 'Sueño fragmentado (tu piel no se regenera, tu cerebro no descansa)', 'Pérdida de masa muscular (metabolismo lento, cuerpo sin fuerza)'];
  const wellaging = ['Despertar con energía (sin necesitar alarmas múltiples)', 'Mirarte al espejo y reconocerte (piel luminosa, ojos despiertos)', 'Moverte sin dolor ni rigidez (cuerpo ágil y fuerte)', 'Dormir profundo (tu cuerpo se regenera de verdad)', 'Sentir seguridad y confianza (sabés que estás haciendo lo correcto)'];
  return <Section bg="white" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <div className="text-center mb-20" data-id="element-28">
          <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-29">
            El Problema Real
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-charcoal leading-tight mb-6" data-id="element-30">
            La industria del antiaging te mintió{' '}
            <span className="italic text-olive" data-id="element-31">durante décadas.</span>
          </h2>
          <p className="text-xl text-charcoal-light font-light max-w-2xl mx-auto" data-id="element-32">
            Y por qué el Wellaging es completamente diferente.
          </p>
        </div>

        <div className="space-y-24" data-id="element-33">
          {/* The Problem */}
          <div className="relative" data-id="element-34">
            <div className="absolute top-0 left-8 w-px h-full bg-gradient-to-b from-gold/0 via-gold/30 to-gold/0 hidden md:block" data-id="element-35" />
            <div className="md:pl-20" data-id="element-36">
              <p className="text-xl mb-8 text-charcoal font-serif italic" data-id="element-37">
                Si tenés más de 40 años, probablemente gastaste miles de pesos
                en:
              </p>
              <ul className="space-y-6 mb-12" data-id="element-38">
                {lies.map((lie, i) => <li key={i} className="flex items-start gap-4 group" data-id="element-39">
                    <div className="mt-1 p-1 rounded-full bg-charcoal/5 group-hover:bg-charcoal/10 transition-colors" data-id="element-40">
                      <X className="w-4 h-4 text-charcoal/40" data-id="element-41" />
                    </div>
                    <span className="text-charcoal-light font-light text-lg leading-relaxed" data-id="element-42">
                      {lie}
                    </span>
                  </li>)}
              </ul>

              <div className="glass-card p-8 md:p-10 rounded-2xl border-l-2 border-l-gold" data-id="element-43">
                <p className="font-serif italic text-2xl text-charcoal mb-6" data-id="element-44">
                  ¿Y qué pasó?
                </p>
                <div className="space-y-3 text-charcoal-light font-light text-lg" data-id="element-45">
                  <p data-id="element-46">Tu piel sigue igual. O peor.</p>
                  <p data-id="element-47">Te seguís sintiendo cansada todo el día.</p>
                  <p data-id="element-48">
                    Te mirás al espejo y sentís que tu cara ya no refleja cómo
                    te sentís por dentro.
                  </p>
                  <p data-id="element-49">
                    Perdiste masa muscular. Ganaste kilos que no podés bajar.
                  </p>
                  <p className="text-olive font-medium mt-6" data-id="element-50">
                    Y lo peor: te resignaste a que "así es envejecer".
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* The Big Idea */}
          <div className="relative" data-id="element-51">
            <div className="absolute -inset-10 bg-olive-light/5 rounded-[4rem] blur-2xl -z-10" data-id="element-52" />
            <div className="bg-cream p-10 md:p-16 rounded-[2.5rem] border border-gold/10 shadow-soft" data-id="element-53">
              <div className="text-center mb-12" data-id="element-54">
                <h3 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-55">
                  Pero acá está la verdad que la industria no quiere que sepas:
                </h3>
                <p className="text-xl md:text-2xl font-light text-charcoal-light mb-2" data-id="element-56">
                  El envejecimiento acelerado NO empieza en la piel.
                </p>
                <p className="text-2xl md:text-3xl font-serif italic text-olive" data-id="element-57">
                  Empieza en la inflamación celular.
                </p>
              </div>

              <p className="text-center text-lg text-charcoal-light font-light mb-12 max-w-2xl mx-auto" data-id="element-58">
                Cada crema "antiaging" que probaste atacaba síntomas externos.
                Pero el verdadero problema está adentro:
              </p>

              <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-59">
                {truths.map((truth, i) => <div key={i} className="flex items-start gap-4 bg-white/50 p-5 rounded-xl border border-white" data-id="element-60">
                    <Flame className="w-5 h-5 text-terracotta shrink-0 mt-0.5 opacity-70" data-id="element-61" />
                    <span className="text-charcoal-light font-light" data-id="element-62">
                      {truth}
                    </span>
                  </div>)}
              </div>

              <div className="mt-12 text-center" data-id="element-63">
                <p className="text-xl font-serif text-charcoal mb-2" data-id="element-64">
                  Esa combinación es lo que te hace sentir y verte "vieja".
                </p>
                <p className="text-lg text-olive font-medium" data-id="element-65">
                  No tu edad. Y ninguna crema puede arreglar eso.
                </p>
              </div>
            </div>
          </div>

          {/* The Paradigm Shift */}
          <div className="bg-olive-deep text-cream-light rounded-[2.5rem] p-10 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-66">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-67" />

            <div className="relative z-10" data-id="element-68">
              <div className="text-center mb-12" data-id="element-69">
                <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-4" data-id="element-70">
                  El Cambio de Paradigma
                </p>
                <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-71">
                  Por eso nació el Wellaging.
                </h3>
                <p className="text-xl font-light opacity-90 max-w-2xl mx-auto" data-id="element-72">
                  En lugar de luchar contra tu edad... Optimizás tu cuerpo para
                  que envejezca con vitalidad.
                </p>
              </div>

              <p className="text-center text-lg font-light mb-12 opacity-80 max-w-2xl mx-auto" data-id="element-73">
                No se trata de "verte de 25 de nuevo" (eso es imposible y no es
                el objetivo). Se trata de:
              </p>

              <div className="grid md:grid-cols-2 gap-x-8 gap-y-6 max-w-3xl mx-auto mb-16" data-id="element-74">
                {wellaging.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-75">
                    <div className="mt-1 p-1 rounded-full bg-gold/20" data-id="element-76">
                      <Check className="w-4 h-4 text-gold" data-id="element-77" />
                    </div>
                    <span className="text-lg font-light opacity-90 leading-relaxed" data-id="element-78">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="text-center border-t border-white/10 pt-10" data-id="element-79">
                <p className="text-3xl font-serif italic text-gold mb-3" data-id="element-80">
                  Eso es Wellaging.
                </p>
                <p className="text-lg font-light opacity-70 tracking-wide uppercase text-sm" data-id="element-81">
                  Y la ciencia lo respalda 100%.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}